import { IDataContextProvider } from "@refinedev/core/dist/contexts/data/IDataContext";
import { AxiosInstance } from "axios";

import { DataProvider } from "@refinedev/core";
import fnlAPI from "../../../../api/fnl-axios-instance";

export const mappingLeonBDataProvider = (
  apiUrl: string,
  httpClient: AxiosInstance = fnlAPI
): DataProvider =>
  <IDataContextProvider>{
    getList: async ({ resource, sort, meta }) => {
      const leagueId = 300;

      const url = "/api/v1/cms/test/leon_b/teams/all";

      const query = {
        leagueId,
      };

      try {
        const { data, headers } = await httpClient.get(`${url}`);
        return {
          data,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    create: async ({
      resource,
      meta,
      variables,
    }: {
      meta: {
        leagueId: string;
        melbetTeam: string;
        fnlTeam: string;
      };
      resource: string;
      variables: {
        fnlTeam: string;
      };
    }) => {
      const url = "/api/v1/cms/test/update-book/teams";

      const { melbetTeam, fnlTeam } = meta;
      const leagueId = 300;
      try {
        await httpClient.post(url, {
          melbetTeam,
          leagueId,
          ...variables,
          fnlTeam,
        });

        return Promise.resolve();
      } catch (error: any) {
        return Promise.reject(error);
      }
    },
  };
